import { Company } from '../../models/company.model';
import BaseApi from './BaseApi';

/**
 * LINE問い合わせチャット詳細取得API。
 */
class GetCompanyDataApi extends BaseApi {
  async get() {
    return await this.execute('getCompanyProfileApi', {
      method: 'GET'
    }).then(({ result }) => result as Company);
  }
}

export default GetCompanyDataApi;
